export default function useTransactionsApi() {
	const GetTransactions = async (query: RecordSchema, skipStore = false) => {
		const { data, error } = await useAPI<IRequestResponse<TransactionsResponse>>('/transactions', {
			query
		})
		if (!error.value && data.value?.data && !skipStore) {
			const { setTransactions } = useStore()
			setTransactions(data.value?.data)
		}
		return data.value
	}

	const GetTransaction = async (payload: string) => {
		const { data } = await useAPI<IRequestResponse<TransactionResponse>>(`/transactions/${payload}`)

		return data.value
	}

	async function GenerateTransaction(payload: TransactionParameter) {
		return await useAPI<IRequestResponse<GenerateTransactionResponse | null>>('/transactions', {
			body: payload,
			method: 'POST'
		})
	}

	async function GetWalletWithdrawals(page = 0) {
		const { data } = await useAPI<IRequestResponse<TransactionsResponse>>(`/wallet/withdrawals?page=${page}`)
		return data.value
	}

	const generateCardReference = async () => {
		const { data } = await useAPI<
			IRequestResponse<{
				payment_url: string
				transaction: TransactionResponse
			}>
		>('/transactions/generate/card-reference')
		return data.value
	}
	const removeCard = async (payload: { password: string; card_id: string }) => {
		const { data } = await useAPI<IRequestResponse<null>>(`/cards/${payload.card_id || ''}`, {
			body: payload,
			method: 'DELETE'
		})
		return data.value
	}
	const saveCard = async (payload: FundWalletParameters & { save_card: 'true' }) => {
		const { data } = await useAPI<IRequestResponse<WalletResponse>>('/wallet/fund', {
			body: payload,
			method: 'POST'
		})
		return data.value
	}
	const getCardDetails = async () => {
		const { data } = await useAPI<IRequestResponse<CardDetailsResponse>>('/cards')
		return data.value?.data || null
	}

	const exportTransactions = async () => {
		const { data } = await useAPI<Blob | File>('transactions/export')
		return data.value
	}

	return {
		GetTransactions,
		GetTransaction,
		GenerateTransaction,
		GetWalletWithdrawals,
		generateCardReference,
		removeCard,
		saveCard,
		getCardDetails,
		exportTransactions
	}
}
